function base() {
	initSmoothScrollAnimation();
	initPreviousReports();
	initTooltips();
	initRevealOnScrollAnimations();
	initTable();
	initTools();
	initIr();
	initCookies();
	initSharer();
	//initMenu();

	document.addEventListener('keydown', function(e) {
		if (e.key === 'Escape') {
			const searchTrigger = document.querySelector('.search-trigger');
			searchTrigger.setAttribute('aria-expanded', 'false');

		}
	});
}
